export const TRANSPORTES = [
  { value: 'PROPRIO', label: 'Próprio', hex: '#3366cc' },
  { value: 'ONIBUS', label: 'Ônibus', hex: '#e67e22' }
]

export const AVISO_VOLTA = 'Apenas quem vier de ônibus terá vaga na volta. Quem vier de veículo próprio não poderá voltar no ônibus.'

export function getTransporte(value) {
  return TRANSPORTES.find(t => t.value === value) || null
}
